// extracted by mini-css-extract-plugin
export default {"waterMarkContainer":"WaterMark_waterMarkContainer__rAfA-","hideWaterMark":"WaterMark_hideWaterMark__5PH4M"};